/**
 * Validates the input value against required flag and custom validators.
 * Extracted to module level to remove nesting-bonus CC from the component.
 * Shared between Input.tsx (native) and Input.web.tsx.
 */
export function validateInput(
  text: string,
  required: boolean,
  validators: Array<{rule: (text: string) => boolean; message: (t: (key: string) => string) => string}>,
  t: (key: string) => string,
): string {
  if (required && !text) {
    return t('mandatoryField');
  }
  for (const validator of validators) {
    if (!validator.rule(text)) {
      return validator.message(t);
    }
  }
  return '';
}